/**
 * Rotates all AtiAdv on the page.
 */
const rotateAtiAdv = () => {
  try {
    if (window.advHelper) {
      const getManagerInstance =
        window.advHelper.getAdvManagerInstance || window.advHelper.getManagerInstance;
      const manager = getManagerInstance();
      manager.rotateAtiAdv(true);
    }
  } catch {
    // eslint-disable-next-line no-console
    console.error('В хелпере что-то поменялось!!!');
  }
};

export default rotateAtiAdv;
